<template>
  <v-col cols="12">
    <v-divider class="primary" />
  </v-col>
</template>

<script>
export default {
   name: 'HorizontalLine',
   model: {
      prop: 'form',
      event: 'update:form'
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: Object,
         required: true,
      },
   },
}
</script>
